import ListNameRenderer from '@app/components/ListNameRenderer';
import ListUpsertByRenderer from '@app/components/ListUpsertByRenderer';
import { type OwnerField } from '@app/queries/list/getLists';
import { type DataTypeType } from '@repo/advanced-filters';
import { translate, TranslationEntity } from '@repo/utils';

export enum ListAttributeSchemaNames {
  name = 'name',
  description = 'description',
  memberCount = 'member_count',
  listType = 'list_type',
  createdBy = 'created_by',
  updatedBy = 'updated_by',
  createdAt = 'created_at',
  updatedAt = 'updated_at',
}

export const DEFAULT_VISIBLE_COLUMNS = [
  ListAttributeSchemaNames.name,
  ListAttributeSchemaNames.description,
  ListAttributeSchemaNames.memberCount,
  ListAttributeSchemaNames.createdBy,
  ListAttributeSchemaNames.updatedBy,
];

export const SORTABLE_FIELDS = [
  ListAttributeSchemaNames.name,
  ListAttributeSchemaNames.memberCount,
  ListAttributeSchemaNames.createdBy,
  ListAttributeSchemaNames.updatedBy,
];

export const SORTABLE_FIELD_MAPPING = {
  [ListAttributeSchemaNames.name]: 'name',
  [ListAttributeSchemaNames.memberCount]: 'member_count',
  [ListAttributeSchemaNames.createdBy]: 'created_at',
  [ListAttributeSchemaNames.updatedBy]: 'updated_at',
};

export const LIST_ATTRIBUTE_CONFIG : Record<string, {
  title: string;
  dataType: DataTypeType,
  render?: any;
}> = {
  [ListAttributeSchemaNames.name]: {
    title: translate(`#{${TranslationEntity.list}} Name`, [{
      capitalize: true,
    }]),
    dataType: 'string',
    render: (name: string, record: any) => <ListNameRenderer name={name} record={record} />,
  },
  [ListAttributeSchemaNames.memberCount]: {
    title: 'Member Count',
    dataType: 'string',
  },
  [ListAttributeSchemaNames.description]: {
    title: 'Description',
    dataType: 'string',
  },
  [ListAttributeSchemaNames.listType]: {
    title: translate(`#{${TranslationEntity.list}} Type`, [{
      capitalize: true,
    }]),
    dataType: 'string',
  },
  [ListAttributeSchemaNames.createdBy]: {
    title: 'Created By (Date)',
    dataType: 'string',
    render: (
      ownerDetails: OwnerField,
      record: any,
    ) => (
      <ListUpsertByRenderer
        ownerName={ownerDetails.fullName}
        record={record}
        dateProperty={ListAttributeSchemaNames.createdAt}
      />
    ),
  },
  [ListAttributeSchemaNames.updatedBy]: {
    title: 'Modified By (Date)',
    dataType: 'string',
    render: (
      ownerDetails: OwnerField,
      record: any,
    ) => (
      <ListUpsertByRenderer
        ownerName={ownerDetails.fullName}
        record={record}
        dateProperty={ListAttributeSchemaNames.updatedAt}
      />
    ),
  },
};
